/* eslint-disable react/prop-types */
import React from 'react';
import { FILTER_TYPE, FILTER_DROPDOWN_TYPE } from 'helpers/constants';
import FilterItem from './Item';
import classes from './FilterBar.module.scss';


const FilterBar = () => {
  const items = [
    {
      key: 'supplier',
      label: 'Supplier',
      type: FILTER_TYPE.FILTER,
      dropdown: {
        type: FILTER_DROPDOWN_TYPE.LIST,
        options: [{ id: 1 }],
      }
    },
    {
      key: 'location',
      label: 'Location',
      type: FILTER_TYPE.FILTER,
      dropdown: {
        type: FILTER_DROPDOWN_TYPE.CHOOSING,
      }
    },
    {
      key: 'productCategory',
      label: 'Product Category',
      type: FILTER_TYPE.FILTER,
      dropdown: {
        type: FILTER_DROPDOWN_TYPE.DATE,
      }
    },
    {
      key: 'status',
      label: 'Status',
      type: FILTER_TYPE.STATUS,
    },
    {
      key: 'connectStatus',
      label: 'Connect Status',
      type: FILTER_TYPE.STATUS,
    },
    {
      key: 'rating',
      label: 'Rating',
      type: FILTER_TYPE.RATING,
    },
    {
      key: 'lastModified',
      label: 'Sort by Last Modified',
      type: FILTER_TYPE.RATING,
    },
  ];
  return (
    <div className={classes.wrapper}>
      <ul>
        {items.map((item) => {
          return (
            <FilterItem key={item.key} item={item} defaultChecks={[]} defaultDate={null} onApply={() => {}} onReset={() => {}} />
          );
        })}
        <FilterItem isReset isDisabled>
          <span className={classes.label}>Reset</span>
        </FilterItem>
      </ul>
    </div>
  );
};

export default FilterBar;
